<template>
  <tbody>
    <slot />
  </tbody>
</template>
